import { takeLatest } from "redux-saga/effects";
import { postCreateOrderExchangePointApi } from "store/api/GiftExchangeApi";
import { CREATE_ORDER_EXCHANGE_POINT_ACTION } from "../../actions/GiftExchangePageAction/actionTypes";

function* postCreateOrderExchangePoint(action) {
	const { data, onSuccess, onError } = action.params;
	const res = yield postCreateOrderExchangePointApi(data);
	try {
		if (res?.code === 0) {
			onSuccess();
		} else {
			onError();
		}
	} catch (e) {
		console.log(e);
	}
}

function* postCreateOrderExchangePointSaga() {
	yield takeLatest(
		CREATE_ORDER_EXCHANGE_POINT_ACTION,
		postCreateOrderExchangePoint
	);
}

export default postCreateOrderExchangePointSaga;
